export default {items: []};


// WEBPACK FOOTER //
// ./src/autoform/_nav.js